import { render, staticRenderFns } from "./summary2.vue?vue&type=template&id=21afc846&"
import script from "./summary2.vue?vue&type=script&lang=js&"
export * from "./summary2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports